<div class="card mb-0 h-full flex flex-col">
  <div class="flex justify-between items-start mb-4">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Executions by Day</span>
      <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">
        @if (loading()) {
          <p-skeleton height="2rem" width="4rem"></p-skeleton>
        } @else {
          {{ getTotalTasks() }}
        }
      </div>
    </div>
    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-chart-bar text-blue-500 text-lg"></i>
    </div>
  </div>
  
  <div class="flex-1 min-h-0">
    @if (loading()) {
      <p-skeleton height="100%" width="100%"></p-skeleton>
    } @else if (data().length === 0) {
      <div class="flex items-center justify-center h-full text-muted-color">
        <div class="text-center">
          <i class="pi pi-chart-bar text-4xl mb-2"></i>
          <p class="text-sm">No data available</p>
        </div>
      </div>
    } @else {
      <div class="h-full">
        <p-chart 
          type="bar"
          class="h-full"
          [data]="chartData" 
          [options]="chartOptions">
        </p-chart>
      </div>
    }
  </div>
  
  <div class="flex items-center text-xs mt-3">
    <i class="pi pi-calendar text-blue-500 mr-1"></i>
    <span class="text-blue-600 font-medium">This month</span>
  </div>
</div>
